"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIAbortController = void 0;
class APIAbortController {
    constructor(abortError) {
        this.abortError = abortError;
        this.controller = new AbortController();
        this.inUse = false;
        this.aborted = false;
        this.abortThrown = false;
    }
    static THROW_IF_ABORTED(controller) {
        if (controller)
            controller.throwIfAborted();
    }
    static IS_ABORTED(controller) {
        return (controller !== undefined && controller.getAborted());
    }
    throwIfAborted() {
        if (this.aborted && !this.abortThrown) {
            this.abortThrown = true;
            throw (this.abortError);
        }
    }
    getAborted() {
        return this.aborted;
    }
    reset() {
        this.renew();
        this.aborted = this.abortThrown = this.inUse = false;
    }
    release() {
        if (!this.aborted) {
            this.renew();
            this.inUse = false;
            return true;
        }
        else
            return false;
    }
    renew() {
        if (this.inUse) {
            this.controller = new AbortController();
        }
        else
            this.inUse = true;
        return this.controller.signal;
    }
    abort() {
        if (!this.aborted) {
            this.aborted = true;
            this.controller.abort(this.abortError.message);
            this.renew();
            this.inUse = false;
            return true;
        }
        else {
            return false;
        }
    }
}
exports.APIAbortController = APIAbortController;
